<template>
    <md-table-row>
        <index-table-cell v-if="canSelected" class="text-center">
            <md-checkbox v-model="isSelected"/>
        </index-table-cell>
        <slot/>
    </md-table-row>
</template>

<script>
    import IndexTableCell from "./IndexTableCell";
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "IndexTableRow",
        props: {
            item: {
                type: Object,
                required: true,
            },
            canSelected: {
                type: Boolean,
                default: false,
            }
        },
        components: {IndexTableCell},
        computed: {
            isSelected: {
                get() {
                    return this.selectedItems.find(selectedItem => {
                        return selectedItem.id === this.item.id;
                    }) !== undefined;
                },
                set(value) {
                    if (value) {
                        this.addSelectedItem(this.item);
                    } else {
                        this.removeSelectedItem(this.item.id);
                    }
                }
            },
            ...mapGetters('indexTable', {
                selectedItems: 'getSelectedItems',
            }),
        },
        methods: {
            ...mapMutations('indexTable', {
                addSelectedItem: 'addSelectedItem',
                removeSelectedItem: 'removeSelectedItem',
            })
        }
    }
</script>

<style lang="scss" scoped>
    .md-checkbox {
        margin: 0 6px;
    }
</style>